import "./MeetingNav.scss";

import AppRoutes from "AppRoutes";
import { BiLock } from "components/Icons/BiLock";
import { OutputDocuments } from "components/OutputDocuments/OutputDocuments";
import { useAgendaItem, useLayout } from "providers";
import { useBoard } from "providers";
import { useDocument } from "providers";
import { useMeeting } from "providers";
import { useParticipant } from "providers";
//import { useTask } from "providers";
import { useTranslations } from "providers";
import React, { useMemo } from "react";

import { AgendaItemsWarning } from "./AgendaItemsWarning";
import { ParticipantsWarning } from "./ParticipantsWarning";

interface MeetingNavItem {
  text: string;
  getUrl: () => string;
  getCount: () => number;
  isDisabled?: () => boolean;
}

export const MeetingNav: React.FC = () => {
  const i18n = useTranslations();
  const { handleNavClick } = useLayout();
  const { board } = useBoard();
  const { meeting, meetingId } = useMeeting();
  const { agendaItems } = useAgendaItem();
  const { participants } = useParticipant();
  //const { tasks } = useTask();
  const { documents } = useDocument();

  const items = useMemo(() => {
    if (!meetingId || !board) {
      return [];
    }

    return [
      {
        text: i18n.Page_Meeting_Title,
        getUrl: () => AppRoutes.toBoardMeeting(meetingId, board),
      },
      {
        text: i18n.Page_AgendaItems_Title,
        getUrl: () => AppRoutes.toBoardMeetingAgendaItems(meetingId, board),
        getCount: () => agendaItems?.length,
      },
      {
        text: i18n.Page_Participants_Title,
        getUrl: () => AppRoutes.toBoardMeetingParticipants(meetingId, board),
        getCount: () => participants?.length,
      },
      /*
      {
        text: i18n.Page_Tasks_Title,
        getUrl: () => AppRoutes.toTasks(meetingId, boardName),
        getCount: () => tasks?.length,
      },
      */
      {
        text: i18n.Page_Documents_Title,
        getUrl: () => AppRoutes.toBoardMeetingDocuments(meetingId, board),
        getCount: () => documents?.length,
      },
      {
        text: i18n.Page_OneDriveSync_Title,
        getUrl: () => AppRoutes.toBoardMeetingOneDriveSync(meetingId, board),
        isDisabled: () => !meeting?.canSyncDocuments,
      },
    ] as MeetingNavItem[];
  }, [i18n, board, meetingId, meeting, agendaItems, participants, documents]);

  if (items.length === 0) {
    return null;
  }

  const { locked, isTemplate } = meeting || {};

  return (
    <>
      <div className="d-flex meeting-nav">
        <ul className="nav nav-pills">
          {items.map((item) => {
            const { getUrl, text, getCount, isDisabled } = item;
            const url = getUrl();
            const count = getCount ? getCount() : 0;
            const selected = url === window.location.pathname;
            const disabled = isDisabled ? isDisabled() : false;
            const className = `nav-link ${selected ? " active" : ""} ${disabled ? " disabled" : ""}`;

            return (
              <li key={url} className={`nav-item`}>
                <button className={className} onClick={() => handleNavClick(url)}>
                  {text}
                  {count > 0 ? <span className="small ml-1 text-muted">({count})</span> : ""}
                </button>
              </li>
            );
          })}
          <li>
            <ParticipantsWarning />
            <AgendaItemsWarning />
          </li>
        </ul>

        <div className="ml-auto text-right output-documents">
          <OutputDocuments />
        </div>
      </div>

      {locked && (
        <div className="meeting-navbar-notice meeting-locked">
          <BiLock />
          {i18n.AgendaItem_NavBar_MeetingLocked}
        </div>
      )}

      {isTemplate && (
        <div className="meeting-navbar-notice meeting-istemplate">
          <i className="ms-Icon ms-Icon--FileTemplate" />
          {i18n.AgendaItem_NavBar_MeetingIsTemplate}
        </div>
      )}
    </>
  );
};
